import React from 'react';
import {
  Box, Flex, Text, useColorModeValue,
} from '@chakra-ui/react';
import DashPanel from './DashPanel';
import { moneyRounded as money } from '../../utils/money'; // item 327 — stealth-aware

// Top customers by invoiced revenue (item 65) — a short leaderboard with a mini
// proportion bar per row (relative to the top customer).
export interface TopCustomer { name: string, total: number }

const TopCustomersCard: React.FC<{ customers: TopCustomer[] }> = ({ customers }) => {
  const nameColor = useColorModeValue('gray.800', 'whiteAlpha.900');
  const subColor = useColorModeValue('gray.500', 'whiteAlpha.600');
  const trackBg = useColorModeValue('blackAlpha.100', 'whiteAlpha.100');
  const max = customers.reduce((mx, c) => Math.max(mx, c.total), 0) || 1;

  return (
    <DashPanel label="Top customers" accent="brandGreen.400">
      {customers.length === 0 && (
        <Text fontSize="sm" color={subColor}>No invoiced revenue yet.</Text>
      )}
      <Flex direction="column" gap={4}>
        {customers.map((c, i) => (
          <Box key={c.name}>
            <Flex align="baseline" justify="space-between" mb={1.5} gap={3}>
              <Text fontSize="sm" fontWeight="semibold" color={nameColor} noOfLines={1}>
                <Box as="span" color={subColor} mr={2}>{`${i + 1}.`}</Box>
                {c.name || 'Unnamed'}
              </Text>
              <Text fontSize="sm" fontWeight="bold" color={nameColor} flexShrink={0}>{money(c.total)}</Text>
            </Flex>
            <Box h="6px" borderRadius="full" bg={trackBg} overflow="hidden">
              <Box
                h="full"
                w={`${Math.max(4, (c.total / max) * 100)}%`}
                borderRadius="full"
                bgGradient="linear(to-r, brandGreen.400, brandGreen.600)"
              />
            </Box>
          </Box>
        ))}
      </Flex>
    </DashPanel>
  );
};

export default TopCustomersCard;
